import React, {memo, useRef} from "react";
import Stop from "images/objectPanel/ic_stop.svg";
import Play from "images/objectPanel/ic_play.svg";
import classNames from "classnames/bind";
import {useClickOutside} from "hooks";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

/**
 * @type appearance {hasNoPlayButton, noOpacity}
 */

function OverlayPlayButton({children, handlePlay, stopPlay, isPlaying, appearance}) {
  const clickOustsideRef = useRef();
  const exceptRef = useRef();
  useClickOutside(clickOustsideRef, stopPlay, exceptRef);

  return (
    <div className={styles.container} ref={clickOustsideRef}>
      {children}
      <button
        ref={exceptRef}
        className={cn("overlay", appearance?.noOpacity && "no_opacity", appearance?.hasNoPlayButton && "no_play_button")}
        onClick={handlePlay}
      >
        <img src={!isPlaying ? Play : Stop} alt="play_button" />
      </button>
    </div>
  );
}

export default memo(OverlayPlayButton);
